export default __webpack_public_path__ + "static/media/community.45db734a.png";